<template>
    <div v-if="user">
        <convention-obligations-select v-if="!canViewAllConventions && !isMyConvention" :user="user" :convention="convention" />
        <convention-obligations v-if="canViewAllConventions || isMyConvention" :convention="convention" />
    </div>
</template>

<script>
import ConventionObligations from "./ConventionObligations.vue"
import ConventionObligationsSelect from "./ConventionObligationsSelect.vue"
import userMixin from "src/mixins/user"

export default {
    mixins: [userMixin],
    components: { ConventionObligationsSelect, ConventionObligations 

    },
    props: ["convention", "user"],
    computed: {
        isMyConvention() {
            return this.hasConventionFamily(this.convention);
        }
    }
}
</script>

<style scoped lang="sass">

</style>